export default "__VITE_ASSET__Bmv5VAgI__"